import React from 'react'
import { Question } from '../Question/Question'
import { List } from 'components/shared/List/List'

export const Questions = ({ questions, isWordDoc }) => {
  return (
    <List direction="column">
      {questions.map(({ description, id, title }, index) => (
        <Question {...{ title, description, index, isWordDoc }} key={id} />
      ))}
    </List>
  )
}
